import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useMediaQuery, useTheme } from '@material-ui/core';
import { isNil } from "lodash";
import { Document, Page, pdfjs } from "react-pdf";
import {
  CircularProgress,
  ClickAwayListener,
  Collapse,
  Drawer,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Hidden,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  green,
  grey,
} from "@material-ui/core/colors";
import {
  X as Clear,
  CircleX as IconCircleX,
  ChevronDown as ExpandMore,
  ChevronUp as ExpandLess,
  Search,
  Pencil as Create,
  Reply,
  Plus as IconAdd,
  SmilePlus as IconEmoji,
  Lock as IconPrivateMsg,
  Settings as IconAiConfig,
  Lightbulb as IconAi,
  Zap as IconBolt,
  CalendarClock as IconSchedule,
  Mic as IconMic,
  Play as IconPlay,
  Pause as IconPause,
  Send as IconSend,
  Trash2 as IconTrash,
  Image as IconImage,
  Camera as IconCamera,
  FileUp as IconFileUp,
  UserRound as IconUserRound,
  CornerDownLeft as IconEnter,
} from "lucide-react";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import useQuickMessages from "../../hooks/useQuickMessages";
import ChatiaPopover, { PopoverOptionItem } from "../ChatiaPopover";
import ChatiaDialog, { ChatiaPromptField } from "../ChatiaDialog";
import CustomToggleSwitch from "../CustomToggleSwitch";
import { isString, isEmpty } from "lodash";
import ContactSendModal from "../ContactSendModal";
import CameraModal from "../CameraModal";
import axios from "axios";
import ButtonModal from "../ButtonModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import MessageUploadMedias from "../MessageUploadMedias";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import ScheduleModal from "../ScheduleModal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

if (!pdfjs.GlobalWorkerOptions.workerSrc) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
}

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

// Mapa de bandeiras por código de idioma
const LANGUAGE_FLAGS = {
  "pt-BR": "🇧🇷", "pt": "🇵🇹", "en": "🇺🇸", "es": "🇪🇸",
  "fr": "🇫🇷", "de": "🇩🇪", "it": "🇮🇹", "zh": "🇨🇳",
  "ja": "🇯🇵", "ko": "🇰🇷", "ar": "🇸🇦", "ru": "🇷🇺",
  "hi": "🇮🇳", "tr": "🇹🇷", "nl": "🇳🇱", "pl": "🇵🇱",
  "uk": "🇺🇦", "th": "🇹🇭", "vi": "🇻🇳", "id": "🇮🇩",
  "ms": "🇲🇾", "he": "🇮🇱", "sv": "🇸🇪", "da": "🇩🇰",
  "fi": "🇫🇮", "no": "🇳🇴", "cs": "🇨🇿", "ro": "🇷🇴",
  "hu": "🇭🇺", "el": "🇬🇷", "bg": "🇧🇬", "hr": "🇭🇷",
  "sk": "🇸🇰", "sl": "🇸🇮", "lt": "🇱🇹", "lv": "🇱🇻",
  "et": "🇪🇪", "ca": "🇪🇸", "af": "🇿🇦", "sw": "🇰🇪",
};

const LANGUAGE_NAMES_SHORT = {
  "pt-BR": "PT-BR", "pt": "PT", "en": "EN", "es": "ES",
  "fr": "FR", "de": "DE", "it": "IT", "zh": "ZH",
  "ja": "JA", "ko": "KO", "ar": "AR", "ru": "RU",
  "hi": "HI", "tr": "TR", "nl": "NL", "pl": "PL",
  "uk": "UK", "th": "TH", "vi": "VI", "id": "ID",
  "ms": "MS", "he": "HE", "sv": "SV", "da": "DA",
  "fi": "FI", "no": "NO", "cs": "CS", "ro": "RO",
  "hu": "HU", "el": "EL", "bg": "BG", "hr": "HR",
};

const CloseXIcon = (props) => (
  <IconCircleX size={props?.style?.fontSize || 18} strokeWidth={1.5} {...props} />
);

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    background: "transparent",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "none",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "25%",
  },
  dropInfo: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: 15,
    left: 0,
    right: 0,
  },
  dropInfoOut: {
    display: "none",
  },
  gridFiles: {
    maxHeight: "100%",
    overflow: "scroll",
  },
  newMessageBox: {
    background: "transparent",
    width: "100%",
    display: "flex",
    padding: "6px 20px 10px 20px",
    alignItems: "flex-end",
    position: "relative",
  },
  messageInputWrapper: {
    padding: "10px 14px 6px 14px",
    background: theme.mode === 'light' ? "#ffffff" : "#2a3942",
    display: "flex",
    flexDirection: "column",
    borderRadius: 20,
    flex: 1,
    position: "relative",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    minHeight: 90,
    maxHeight: "80vh",
    overflow: "visible",
    "&:hover $resizeHandle": {
      opacity: 1,
    },
  },
  messageInputWrapperPrivate: {
    padding: "10px 14px 6px 14px",
    background: theme.mode === "light" ? "#ede9fe" : "#2d2440",
    border: theme.mode === "light" ? "1px solid #a78bfa" : "1px solid #4c3d6e",
    display: "flex",
    flexDirection: "column",
    borderRadius: 20,
    flex: 1,
    position: "relative",
    boxShadow: theme.mode === "light"
      ? "0 2px 8px rgba(124,58,237,0.18)"
      : "0 2px 8px rgba(0,0,0,0.35)",
    minHeight: 90,
    maxHeight: "80vh",
    overflow: "visible",
    "&:hover $resizeHandle": {
      opacity: 1,
    },
  },
  resizeHandle: {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: 40,
    height: 12,
    cursor: "ns-resize",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
    opacity: 0,
    transition: "opacity 0.2s",
    "&::after": {
      content: '""',
      width: 28,
      height: 3,
      borderRadius: 2,
      backgroundColor: "rgba(0,0,0,0.25)",
    },
  },
  messageInput: {
    paddingLeft: 0,
    flex: 1,
    border: "none",
    width: "100%",
    overflowY: "auto",
    alignItems: "flex-start",
  },
  messageInputPrivate: {
    paddingLeft: 0,
    flex: 1,
    border: "none",
    color: theme.mode === "light" ? "#4c1d95" : "#e9d5ff",
    width: "100%",
    overflowY: "auto",
    alignItems: "flex-start",
  },
  formatPreview: {
    padding: "4px 8px",
    borderTop: `1px solid ${theme.mode === 'light' ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.08)"}`,
    fontSize: 13,
    lineHeight: 1.4,
    color: theme.mode === 'light' ? "#555" : "#adb5bd",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    maxHeight: 60,
    overflowY: "auto",
    "& b": { fontWeight: 700, color: theme.mode === 'light' ? "#303030" : "#e9edef" },
    "& i": { fontStyle: "italic" },
    "& s": { textDecoration: "line-through" },
    "& code": {
      fontFamily: "monospace",
      fontSize: "0.9em",
      backgroundColor: theme.mode === 'light' ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.08)",
      borderRadius: 3,
      padding: "1px 3px",
    },
  },
  inputBottomRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    borderTop: `1px solid ${theme.mode === 'light' ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.08)"}`,
    marginTop: 4,
    paddingTop: 2,
  },
  translateBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    padding: "2px 8px",
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 500,
    color: "#667781",
    backgroundColor: "rgba(0,0,0,0.06)",
    cursor: "default",
    whiteSpace: "nowrap",
    marginRight: 4,
    height: 24,
  },
  translateFlag: {
    fontSize: 16,
    lineHeight: 1,
  },
  langFlagBtn: {
    padding: 6,
    marginLeft: 2,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "none",
    border: "none",
    transition: "opacity 0.15s ease",
    "&:hover": {
      opacity: 0.7,
    },
  },
  langFlagImg: {
    width: 22,
    height: 15,
    objectFit: "cover",
    borderRadius: 2,
  },
  langPopoverPaper: {
    borderRadius: 12,
    minWidth: 200,
    overflow: "hidden",
    boxShadow: "0 8px 28px rgba(0,0,0,0.12)",
  },
  langPopoverHeader: {
    padding: "10px 14px 8px",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
  },
  langPopoverTitle: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "rgba(0,0,0,0.38)",
  },
  langOptionsList: {
    padding: 4,
  },
  langOptionItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "7px 10px",
    borderRadius: 6,
    cursor: "pointer",
    transition: "all 0.15s ease",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
    },
  },
  langOptionSelected: {
    backgroundColor: "rgba(6,207,156,0.1)",
    "&:hover": {
      backgroundColor: "rgba(6,207,156,0.15)",
    },
  },
  langOptionFlag: {
    width: 26,
    height: 18,
    objectFit: "cover",
    borderRadius: 2,
    border: "1px solid rgba(0,0,0,0.1)",
    flexShrink: 0,
  },
  langOptionName: {
    fontSize: 13,
    fontWeight: 500,
    flex: 1,
  },
  langOptionCheck: {
    color: "#06cf9c",
    fontSize: 16,
  },
  variablesWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: theme.mode === "light" ? "#f0f2f5" : "#1d282f",
    borderRadius: 10,
    maxHeight: 180,
    overflowY: "auto",
    padding: "4px",
    marginBottom: 4,
    ...theme.scrollbarStylesSoft,
  },
  variablesHeader: {
    display: "flex",
    alignItems: "center",
    padding: "6px 10px 4px 10px",
  },
  variablesTitle: {
    fontSize: 11,
    fontWeight: 600,
    color: theme.mode === "dark" ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.35)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  variableItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "6px 10px",
    cursor: "pointer",
    borderRadius: 8,
    transition: "background 0.12s ease",
    "&:hover": {
      background: theme.mode === "dark" ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.05)",
    },
  },
  variableCode: {
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: 600,
    color: theme.mode === "dark" ? "#6eb5ff" : "#1976d2",
    background: theme.mode === "dark" ? "rgba(110,181,255,0.12)" : "rgba(25,118,210,0.08)",
    padding: "3px 7px",
    borderRadius: 5,
    whiteSpace: "nowrap",
    minWidth: 100,
    textAlign: "center",
  },
  variableLabel: {
    fontSize: 12,
    color: theme.mode === "dark" ? "rgba(255,255,255,0.85)" : "#303030",
    fontWeight: 500,
    flex: 1,
  },
  variableDesc: {
    fontSize: 10,
    color: theme.mode === "dark" ? "rgba(255,255,255,0.3)" : "#999",
    marginLeft: "auto",
    textAlign: "right",
  },
  sendMessageIcons: {
    color: grey[700],
  },
  ForwardMessageIcons: {
    color: grey[700],
    transform: 'scaleX(-1)'
  },
  uploadInput: {
    display: "none",
  },
  viewMediaInputWrapper: {
    maxHeight: "100%",
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.mode === 'light' ? "#ffffff" : "#202c33",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },
  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    zIndex: 10,
    "& .emoji-mart": {
      borderRadius: 12,
      border: theme.mode === "light" ? "1px solid rgba(0,0,0,0.1)" : "1px solid rgba(255,255,255,0.1)",
      boxShadow: theme.mode === "light"
        ? "0 4px 20px rgba(0,0,0,0.12)"
        : "0 4px 20px rgba(0,0,0,0.4)",
      backgroundColor: theme.mode === "light" ? "#ffffff" : "#1f2c34",
    },
    "& .emoji-mart-bar": {
      borderColor: theme.mode === "light" ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.08)",
    },
    "& .emoji-mart-search input": {
      borderRadius: 8,
      backgroundColor: theme.mode === "light" ? "#f0f2f5" : "#2a3942",
      borderColor: theme.mode === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
      color: theme.mode === "light" ? "#111b21" : "#e9edef",
    },
    "& .emoji-mart-category-label span": {
      backgroundColor: theme.mode === "light" ? "#ffffff" : "#1f2c34",
      color: theme.mode === "light" ? "#667781" : "#8696a0",
    },
    "& .emoji-mart-scroll": {
      ...theme.scrollbarStyles,
    },
  },
  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },
  audioLoading: {
    color: green[500],
    opacity: "70%",
  },
  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },
  cancelAudioIcon: {
    color: "red",
  },
  sendAudioIcon: {
    color: "green",
  },
  // --- New full-width audio recorder bar ---
  audioRecorderBar: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    gap: 6,
    flex: 1,
    minWidth: 0,
    background: theme.mode === 'light' ? "#fff" : "#2a3942",
    borderRadius: 24,
    padding: "8px 8px 8px 10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  audioRecorderBarPaused: {
    alignItems: "center",
    minHeight: 52,
    paddingTop: 6,
    paddingBottom: 6,
  },
  audioRecDeleteBtn: {
    padding: 4,
    color: "#ffffff",
    flexShrink: 0,
    "&:hover": { backgroundColor: "rgba(244,67,54,0.08)" },
  },
  audioRecDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    flexShrink: 0,
    animation: "$pulse 1s ease-in-out infinite",
  },
  audioRecDotPaused: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    backgroundColor: "#999",
    flexShrink: 0,
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.3 },
  },
  audioRecTimer: {
    fontSize: 14,
    fontWeight: 500,
    fontVariantNumeric: "tabular-nums",
    color: theme.mode === 'light' ? "#333" : "#e9edef",
    minWidth: 40,
    flexShrink: 0,
  },
  audioRecWaveform: {
    flex: 1,
    minWidth: 0,
    height: 32,
    display: "block",
    overflow: "hidden",
    position: "relative",
    "& > div": {
      height: "100%",
    },
    "& canvas": {
      display: "block",
    },
  },
  audioRecPreview: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
    },
  },
  audioRecNativePreview: {
    width: "min(340px, 100%)",
    height: 34,
    display: "block",
    borderRadius: 18,
    overflow: "hidden",
    backgroundColor: theme.mode === "light" ? "#eef3f7" : "#34454f",
    colorScheme: theme.mode === "light" ? "light" : "dark",
    "&::-webkit-media-controls-panel": {
      backgroundColor: theme.mode === "light" ? "#eef3f7" : "#34454f",
    },
  },
  audioRecHiddenWaveform: {
    position: "absolute",
    left: -9999,
    top: 0,
    width: 320,
    height: 40,
    overflow: "hidden",
    opacity: 0,
    pointerEvents: "none",
  },
  audioRecWaveBar: {
    flex: "0 0 2px",
    minWidth: 2,
    borderRadius: 2,
    backgroundColor: theme.mode === "light" ? "rgba(17, 24, 39, 0.24)" : "rgba(255,255,255,0.28)",
    opacity: 0.9,
    transition: "height 28ms linear, background-color 90ms ease, opacity 90ms ease",
  },
  audioRecWaveBarActive: {
    backgroundColor: theme.mode === "light" ? "rgba(17, 24, 39, 0.24)" : "rgba(255,255,255,0.28)",
  },
  audioRecPauseBtn: {
    width: 36,
    height: 36,
    padding: 4,
    flexShrink: 0,
    color: theme.mode === 'light' ? "#333" : "#e9edef",
    "&:hover": { backgroundColor: theme.mode === 'light' ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.08)" },
  },
  audioRecResumeBtn: {
    width: 36,
    height: 36,
    padding: 4,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.mode === 'light' ? "#333" : "#e9edef",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: theme.mode === 'light' ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.08)",
    },
    "& svg": {
      color: "currentColor",
      stroke: "currentColor",
    },
  },
  audioRecSendBtn: {
    width: 36,
    height: 36,
    backgroundColor: "transparent",
    color: "#0b7dda",
    padding: 4,
    flexShrink: 0,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#0960a5",
    },
  },
  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    gap: 6,
    padding: "0 4px 6px 4px",
  },
  replyginMsgContainer: {
    flex: 1,
    overflow: "hidden",
    backgroundColor: theme.mode === "light" ? "#f0f2f5" : "#1d282f",
    borderRadius: 10,
    display: "flex",
    position: "relative",
    maxHeight: 90,
    minWidth: 0,
  },
  replyginMsgBody: {
    padding: "8px 10px",
    height: "auto",
    display: "flex",
    alignItems: "center",
    gap: 10,
    overflow: "hidden",
    fontSize: 13,
    lineHeight: 1.4,
    color: theme.mode === "light" ? "#303030" : "#d1d7db",
    flex: 1,
    minWidth: 0,
  },
  replyginDocIcon: {
    width: 36,
    height: 36,
    objectFit: "contain",
    flexShrink: 0,
  },
  replyginDocInfo: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  replyginDocName: {
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.mode === "light" ? "#111827" : "#e9edef",
    maxWidth: "100%",
  },
  replyginDocMeta: {
    fontSize: 11,
    color: theme.mode === "light" ? "#6b7280" : "#8696a0",
    marginTop: 1,
  },
  replyginCloseBtn: {
    padding: 4,
    borderRadius: "50%",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.mode === "light" ? "#667781" : "#8696a0",
    transition: "all 0.2s ease",
    flexShrink: 0,
    border: "none",
    background: "transparent",
    "&:hover": {
      color: "#e53935",
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  replyginContactMsgSideColor: {
    flex: "none",
    width: 4,
    borderRadius: 4,
    margin: "8px 0 8px 8px",
    backgroundColor: "#1e5a99",
  },
  replyginSelfMsgSideColor: {
    flex: "none",
    width: 4,
    borderRadius: 4,
    margin: "8px 0 8px 8px",
    backgroundColor: "#0e7c6b",
  },
  replyginSenderName: {
    fontSize: 12,
    fontWeight: 600,
    color: "#0e7c6b",
    marginBottom: 2,
  },
  replyginSenderNameContact: {
    fontSize: 12,
    fontWeight: 600,
    color: "#1e5a99",
    marginBottom: 2,
  },
  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  quickAnswersDrawer: {
    "& .MuiDrawer-paper": {
      ...theme.chatiaDS.dialogPaper,
      width: 380,
      maxWidth: "85vw",
      maxHeight: "none !important",
      height: "100%",
      backgroundColor: theme.mode === "light" ? "#ffffff !important" : "#121212 !important",
      backgroundImage: "none !important",
      borderRadius: "21px 0 0 12px !important",
      border: "none",
      boxShadow: "-4px 0 24px rgba(0,0,0,0.15)",
    },
  },
  quickAnswersDrawerHeader: {
    ...theme.chatiaDS.header,
  },
  quickAnswersDrawerTitle: {
    ...theme.chatiaDS.headerTitle,
  },
  quickAnswersDrawerClose: {
    backgroundColor: theme.chatiaDS.closeButton.backgroundColor,
    color: theme.chatiaDS.closeButton.color,
    transition: theme.chatiaDS.closeButton.transition,
  },
  quickAnswersSearchBox: {
    margin: "12px 16px",
    display: "flex",
    alignItems: "center",
    background: theme.mode === "light" ? "#f0f2f5" : "#2a3942",
    borderRadius: 12,
    padding: "6px 12px",
    gap: 8,
    "& svg": {
      fontSize: 20,
      color: theme.mode === "light" ? "#8696a0" : "#8696a0",
    },
  },
  quickAnswersSearchInput: {
    flex: 1,
    fontSize: 14,
    color: theme.mode === "light" ? "#3b4a54" : "#d1d7db",
  },
  quickAnswersListArea: {
    flex: 1,
    overflowY: "auto",
    padding: "4px 0",
    ...theme.scrollbarStyles,
    "&::-webkit-scrollbar": {
      width: 5,
    },
  },
  quickAnswersCard: {
    margin: "6px 12px",
    borderRadius: 12,
    border: theme.mode === "light" ? "1px solid #e8e8e8" : "1px solid #2a3942",
    overflow: "hidden",
    transition: "box-shadow 0.15s ease",
    "&:hover": {
      boxShadow: theme.mode === "light"
        ? "0 2px 8px rgba(0,0,0,0.08)"
        : "0 2px 8px rgba(0,0,0,0.25)",
    },
  },
  quickAnswersCardHeader: {
    display: "flex",
    alignItems: "center",
    padding: "10px 14px",
    cursor: "pointer",
    gap: 10,
    "&:hover": {
      background: theme.mode === "light" ? "#f5f6f6" : "#233039",
    },
  },
  quickAnswersCardShortcut: {
    fontSize: 12,
    fontWeight: 700,
    color: theme.mode === "light" ? "#0b7dda" : "#53bdeb",
    background: theme.mode === "light" ? "#e8f4fd" : "#0b3d54",
    borderRadius: 6,
    padding: "3px 8px",
    fontFamily: "monospace",
    flexShrink: 0,
  },
  quickAnswersCardPreview: {
    fontSize: 13,
    color: theme.mode === "light" ? "#667781" : "#8696a0",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    flex: 1,
  },
  quickAnswersCardExpandIcon: {
    color: theme.mode === "light" ? "#8696a0" : "#8696a0",
    fontSize: 20,
    flexShrink: 0,
  },
  quickAnswersCardBody: {
    padding: "0 14px 12px",
    borderTop: theme.mode === "light" ? "1px solid #f0f0f0" : "1px solid #2a3942",
  },
  quickAnswersCardMessage: {
    fontSize: 13,
    lineHeight: 1.5,
    color: theme.mode === "light" ? "#3b4a54" : "#d1d7db",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    padding: "10px 0",
  },
  quickAnswersCardUseBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    fontSize: 12,
    fontWeight: 600,
    color: "#fff",
    background: "#0b7dda",
    border: "none",
    borderRadius: 8,
    padding: "6px 16px",
    cursor: "pointer",
    transition: "background 0.15s",
    "&:hover": {
      background: "#0969b8",
    },
  },
  quickAnswersEmpty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 16px",
    color: theme.mode === "light" ? "#8696a0" : "#8696a0",
    fontSize: 14,
    "& svg": {
      fontSize: 40,
      marginBottom: 12,
      opacity: 0.4,
    },
  },
  flexContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  flexItem: {
    flex: 1,
  },
  sendBtn: {
    backgroundColor: "transparent",
    color: "#0b7dda",
    padding: 6,
    marginLeft: 2,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#0960a5",
    },
  },
  cancelForwardBtn: {
    backgroundColor: "transparent",
    color: theme.mode === "light" ? "#6b7280" : "#aebac1",
    padding: 6,
    marginLeft: 2,
    "&:hover": {
      backgroundColor: "transparent",
      color: "#e53935",
    },
  },
  enterToggle: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    marginLeft: 8,
    userSelect: "none",
    padding: "4px 8px 4px 6px",
    borderRadius: 20,
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
    },
  },
  enterToggleSwitch: {
    "--switch-width": "30px",
    "--switch-height": "16px",
    "--circle-diameter": "12px",
    "--icon-cross-size": "4px",
    "--icon-checkmark-size": "7px",
  },
  inputIconBtn: {
    padding: 6,
    color: grey[500],
    transition: "color 0.15s ease",
    "&:hover": {
      color: "#25D366",
      backgroundColor: "transparent",
    },
  },
  inputIconBtnActive: {
    padding: 6,
    color: "#25D366",
    transition: "color 0.15s ease",
    "&:hover": {
      color: "#128C7E",
      backgroundColor: "transparent",
    },
  },
  formatToolbar: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    background: theme.mode === 'light' ? "#ffffff" : "#2a3942",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
    padding: "4px 6px",
    position: "absolute",
    zIndex: 20,
    whiteSpace: "nowrap",
  },
  formatBtn: {
    minWidth: 32,
    width: 32,
    height: 32,
    padding: 0,
    borderRadius: 6,
    color: theme.mode === 'light' ? "#54656f" : "#aebac1",
    fontSize: 16,
    fontWeight: 700,
    "&:hover": {
      backgroundColor: theme.mode === 'light' ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.08)",
    },
  },
  aiSuggestionsWrapper: {
    position: "absolute",
    bottom: "50px",
    left: 0,
    width: "100%",
    background: theme.mode === "dark" ? "#121212" : "#ffffff",
    border: theme.mode === "dark"
      ? "1px solid rgba(255,255,255,0.08)"
      : "1px solid rgba(0,0,0,0.06)",
    borderRadius: 14,
    boxShadow: "0 10px 36px rgba(0,0,0,0.14)",
    zIndex: 10,
    overflow: "hidden",
  },
  aiSuggestionItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "10px 14px",
    cursor: "pointer",
    transition: "all 0.15s ease",
    "&:hover": {
      background: theme.mode === "dark"
        ? "rgba(255,255,255,0.06)"
        : "rgba(0,0,0,0.04)",
    },
  },
  aiSuggestionBadge: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: 10,
    fontSize: 10,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#fff",
    background: "#6B46C1",
    whiteSpace: "nowrap",
    marginTop: 2,
    flexShrink: 0,
  },
  aiSuggestionText: {
    fontSize: 13,
    color: theme.mode === "dark" ? "#e9edef" : "#1a1a1a",
    lineHeight: 1.4,
    flex: 1,
  },
  aiSuggestionsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 14px",
    background: theme.mode === "light"
      ? "linear-gradient(135deg, #f5f0eb 0%, #e0dcd7 100%)"
      : "linear-gradient(135deg, #2a3942 0%, #1a2a32 100%)",
    borderBottom: theme.mode === "light" ? "1px solid #d5d0cb" : "1px solid #2a3942",
  },
  aiSuggestionsTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.mode === "dark" ? "#e9edef" : "#1a1a1a",
  },
  aiButtonWrapper: {
    position: "relative",
    display: "inline-flex",
    "&:hover $aiConfigBtn": {
      opacity: 1,
      pointerEvents: "auto",
    },
  },
  aiConfigBtn: {
    position: "absolute",
    top: -6,
    right: -6,
    opacity: 0,
    pointerEvents: "none",
    transition: "opacity 0.2s, background-color 0.15s",
    padding: 2,
    background: theme.mode === "light" ? "#ffffff" : "#2a3942",
    color: theme.mode === "light" ? "#374151" : "#e9edef",
    borderRadius: "50%",
    boxShadow: theme.mode === "light"
      ? "0 1px 4px rgba(0,0,0,0.18)"
      : "0 1px 4px rgba(0,0,0,0.5)",
    zIndex: 2,
    "&:hover": {
      background: theme.mode === "light" ? "#f3f4f6" : "#374a55",
    },
    "& svg": {
      fontSize: 14,
    },
  },
}));

const MessageInput = ({ ticketId, ticketStatus, droppedFiles, contactId, ticketChannel, onHeightChange, onMediaPreviewChange }) => {

  const classes = useStyles();
  const theme = useTheme();
  const [mediasUpload, setMediasUpload] = useState([]);
  const isMounted = useRef(true);
  const [buttonModalOpen, setButtonModalOpen] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [enterSends, setEnterSends] = useState(() => {
    try { const v = localStorage.getItem("enterSends"); return v === null ? true : v === "true"; } catch { return true; }
  });
  const [formatToolbarPos, setFormatToolbarPos] = useState(null);
  const [inputHeight, setInputHeight] = useState(90);
  const messageInputRef = useRef(null);
  const dragRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [recordingPaused, setRecordingPaused] = useState(false);
  const [recordingElapsed, setRecordingElapsed] = useState(0);
  const [waveformBars, setWaveformBars] = useState(Array(220).fill(3));
  const hasDetectedSoundRef = useRef(false);
  const [previewPlaying, setPreviewPlaying] = useState(false);
  const [previewAudioUrl, setPreviewAudioUrl] = useState(null);
  const [previewTime, setPreviewTime] = useState(0);
  const previewAudioRef = useRef(null);
  const previewAnimRef = useRef(null);
  const previewBallRef = useRef(null);
  const waveformContainerRef = useRef(null);
  const barsWrapperRef = useRef(null);
  // Audio recording refs (native MediaRecorder + Web Audio API analyser)
  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const audioCtxRef = useRef(null);
  const analyserRef = useRef(null);
  const audioSourceRef = useRef(null);
  const dataArrayRef = useRef(null);
  const animFrameRef = useRef(null);
  const recordingTimerRef = useRef(null);
  const lastBarPushRef = useRef(0);
  const recordedBarsRef = useRef(0);
  const recStartTimeRef = useRef(0);
  const recElapsedRef = useRef(0);
  const formatRecordingTime = (seconds) => {
    const mm = String(Math.floor(seconds / 60)).padStart(2, "0");
    const ss = String(seconds % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const startRecordingTimer = () => {
    if (recordingTimerRef.current) return;
    recordingTimerRef.current = setInterval(() => {
      setRecordingElapsed((seconds) => seconds + 1);
    }, 1000);
  };

  const stopRecordingTimer = () => {
    if (recordingTimerRef.current) {
      clearInterval(recordingTimerRef.current);
      recordingTimerRef.current = null;
    }
  };

  const updatePreviewAudioUrl = (blob) => {
    if (!(blob instanceof Blob) || blob.size === 0) return;
    setPreviewAudioUrl((oldUrl) => {
      if (oldUrl) URL.revokeObjectURL(oldUrl);
      return URL.createObjectURL(blob);
    });
  };

  const clearPreviewAudioUrl = () => {
    setPreviewAudioUrl((oldUrl) => {
      if (oldUrl) URL.revokeObjectURL(oldUrl);
      return null;
    });
  };
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const [quickDrawerOpen, setQuickDrawerOpen] = useState(false);
  const [quickDrawerSearch, setQuickDrawerSearch] = useState("");
  const [quickDrawerExpanded, setQuickDrawerExpanded] = useState(null);
  const inputRef = useRef();
  const [onDragEnter, setOnDragEnter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext);
  const { user, socket } = useContext(AuthContext);
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);

  const [signMessagePar, setSignMessagePar] = useState(false);
  const { get: getSetting, update: updateSetting } = useCompanySettings();
  const [signMessage, setSignMessage] = useState(true);
  const [privateMessage, setPrivateMessage] = useState(false);
  const [privateMessageInputVisible, setPrivateMessageInputVisible] = useState(false);
  const [senVcardModalOpen, setSenVcardModalOpen] = useState(false);
  const [showModalMedias, setShowModalMedias] = useState(false);
  useEffect(() => {
    if (onMediaPreviewChange) onMediaPreviewChange(showModalMedias);
  }, [showModalMedias, onMediaPreviewChange]);
  const [contactLanguage, setContactLanguage] = useState(null);
  const [autoTranslateEnabled, setAutoTranslateEnabled] = useState(false);
  const [langAnchorEl, setLangAnchorEl] = useState(null);
  const [aiSuggestions, setAiSuggestions] = useState([]);
  const draftTimerRef = useRef(null);
  const lastSavedDraftRef = useRef("");
  const ticketNumericIdRef = useRef(null);
  const [showAiSuggestions, setShowAiSuggestions] = useState(false);
  const [loadingAiSuggestions, setLoadingAiSuggestions] = useState(false);
  const [aiConfigOpen, setAiConfigOpen] = useState(false);
  const [aiPrompt, setAiPrompt] = useState("");
  const [aiPromptDraft, setAiPromptDraft] = useState("");
  const [savingAiPrompt, setSavingAiPrompt] = useState(false);
  const [showVariables, setShowVariables] = useState(false);
  const [variableFilter, setVariableFilter] = useState("");

  const { list: listQuickMessages } = useQuickMessages();


  const isMobile = useMediaQuery('(max-width: 767px)'); // Ajuste o valor conforme necessário
  const [placeholderText, setPlaceHolderText] = useState("");

  // Determine o texto do placeholder com base no ticketStatus
  useEffect(() => {
    if (ticketStatus === "open" || ticketStatus === "group") {
      setPlaceHolderText(i18n.t("messagesInput.placeholderOpen"));
    } else {
      setPlaceHolderText(i18n.t("messagesInput.placeholderClosed"));
    }

    // Limitar o comprimento do texto do placeholder apenas em ambientes mobile
    const maxLength = isMobile ? 20 : Infinity; // Define o limite apenas em mobile

    if (isMobile && placeholderText.length > maxLength) {
      setPlaceHolderText(placeholderText.substring(0, maxLength) + "...");
    }
  }, [ticketStatus])

  // Reportar altura do MessageInput para o componente pai
  useEffect(() => {
    if (!onHeightChange || !messageInputRef.current) return;
    const el = messageInputRef.current;
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        onHeightChange(entry.contentRect.height);
      }
    });
    observer.observe(el);
    // Reportar altura inicial
    onHeightChange(el.offsetHeight);
    return () => observer.disconnect();
  }, [onHeightChange]);

  const {
    selectedMessages,
    setSelectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox,
    setShowSelectMessageCheckbox } = useContext(ForwardMessageContext);

  // Buscar idioma do contato e config de tradução
  useEffect(() => {
    let cancelled = false;
    async function fetchTranslateInfo() {
      try {
        if (contactId) {
          const { data } = await api.get(`/translate/contact/${contactId}/language`);
          if (!cancelled) {
            setContactLanguage(data.language || "pt-BR");
          }
        }
        const { data: settings } = await api.get("/translate/settings");
        if (!cancelled) {
          setAutoTranslateEnabled(settings.autoTranslate === "enabled");
        }
      } catch (err) {
        if (!cancelled) setContactLanguage("pt-BR");
      }
    }
    fetchTranslateInfo();
    return () => { cancelled = true; };
  }, [contactId]);

  // Carregar prompt IA salvo
  useEffect(() => {
    async function loadAiPrompt() {
      try {
        const setting = await getSetting({ column: "aiSuggestionsPrompt" });
        if (setting?.aiSuggestionsPrompt) {
          setAiPrompt(setting.aiSuggestionsPrompt);
        }
      } catch {}
    }
    loadAiPrompt();
  }, []);

  useEffect(() => {
    if (droppedFiles && droppedFiles.length > 0) {
      const selectedMedias = Array.from(droppedFiles);
      setMediasUpload(selectedMedias);
      setUploadCaptions(selectedMedias.map(() => ""));
      setUploadCurrentIndex(0);
      setShowModalMedias(true);
    }
  }, [droppedFiles]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    inputRef.current.focus();
    if (editingMessage) {
      setInputMessage(editingMessage.body);
    }
  }, [replyingMessage, editingMessage]);

  // Load draft when opening ticket
  useEffect(() => {
    const loadDraft = async () => {
      try {
        const { data } = await api.get(`/tickets/u/${ticketId}`);
        ticketNumericIdRef.current = data?.id || null;
        if (data?.draft && isMounted.current) {
          setInputMessage(data.draft);
          lastSavedDraftRef.current = data.draft;
        }
      } catch (err) {
        // ignore
      }
    };
    if (ticketId) loadDraft();
  }, [ticketId]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      // Save draft immediately on unmount
      if (draftTimerRef.current) clearTimeout(draftTimerRef.current);
      const currentMsg = inputRef.current?.value || "";
      if (currentMsg !== lastSavedDraftRef.current) {
        api.put(`/tickets/u/${ticketId}/draft`, { draft: currentMsg }).catch(() => {});
        if (ticketNumericIdRef.current) {
          window.dispatchEvent(new CustomEvent("ticketDraftUpdate", {
            detail: { ticketId: ticketNumericIdRef.current, draft: currentMsg }
          }));
        }
      }
      setInputMessage("");
      setShowEmoji(false);
      setMediasUpload([]);
      setReplyingMessage(null);
      //setSignMessage(true);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false)
      setEditingMessage(null);
    };
  }, [ticketId, setReplyingMessage, setEditingMessage]);

  // Auto-save draft: emit socket instantly, persist to DB with debounce
  useEffect(() => {
    // Emit event instantly for real-time card update
    if (ticketNumericIdRef.current) {
      window.dispatchEvent(new CustomEvent("ticketDraftUpdate", {
        detail: { ticketId: ticketNumericIdRef.current, draft: inputMessage || "" }
      }));
    }

    if (draftTimerRef.current) clearTimeout(draftTimerRef.current);
    draftTimerRef.current = setTimeout(() => {
      if (!ticketId || !isMounted.current) return;
      const text = inputMessage || "";
      if (text !== lastSavedDraftRef.current) {
        lastSavedDraftRef.current = text;
        api.put(`/tickets/u/${ticketId}/draft`, { draft: text }).catch(() => {});
      }
    }, 1500);
    return () => {
      if (draftTimerRef.current) clearTimeout(draftTimerRef.current);
    };
  }, [inputMessage, ticketId]);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted.current)
        setOnDragEnter(false);
    }, 1000);
    // eslint-disable-next-line
  }, [onDragEnter === true]);

  //permitir ativar/desativar firma
  useEffect(() => {
    const fetchSettings = async () => {
      const setting = await getSetting({
        "column": "sendSignMessage"
      });

      if (isMounted.current) {
        if (setting.sendSignMessage === "enabled") {
          setSignMessagePar(true);
          const signMessageStorage = JSON.parse(
            localStorage.getItem("persistentSignMessage")
          );
          if (isNil(signMessageStorage)) {
            setSignMessage(true)
          } else {
            setSignMessage(signMessageStorage);
          }
        } else {
          setSignMessagePar(false);
        }
      }
    };
    fetchSettings();
  }, []);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleSendLinkVideo = async () => {
    const link = `https://meet.jit.si/${ticketId}`;
    setInputMessage(link);
  }

  const handleAiSuggestions = async () => {
    if (loadingAiSuggestions) return;
    setLoadingAiSuggestions(true);
    setShowAiSuggestions(false);
    try {
      const { data } = await api.post(`/messages/${ticketId}/ai-suggestions`, {
        draftText: inputMessage.trim() || undefined
      });
      if (data.suggestions && data.suggestions.length > 0) {
        setAiSuggestions(data.suggestions);
        setShowAiSuggestions(true);
      } else {
        toastError({ response: { data: { message: i18n.t("messageOptionsMenu.aiGenerationFailed") } } });
      }
    } catch (err) {
      toastError(err);
    }
    setLoadingAiSuggestions(false);
  };

  const handleSelectAiSuggestion = (text) => {
    setInputMessage(text);
    setShowAiSuggestions(false);
    setAiSuggestions([]);
    inputRef.current?.focus();
  };

  const handleOpenAiConfig = () => {
    setAiPromptDraft(aiPrompt);
    setAiConfigOpen(true);
  };

  const handleSaveAiPrompt = async () => {
    setSavingAiPrompt(true);
    try {
      await updateSetting({ column: "aiSuggestionsPrompt", data: aiPromptDraft });
      setAiPrompt(aiPromptDraft);
      setAiConfigOpen(false);
    } catch (err) {
      console.error("Erro ao salvar prompt IA:", err);
    }
    setSavingAiPrompt(false);
  };

  const TEMPLATE_VARIABLES = [
    { variable: "{{firstName}}", label: i18n.t("messageVariablesPicker.templates.firstName.label"), description: i18n.t("messageVariablesPicker.templates.firstName.description") },
    { variable: "{{name}}", label: i18n.t("messageVariablesPicker.templates.name.label"), description: i18n.t("messageVariablesPicker.templates.name.description") },
    { variable: "{{userName}}", label: i18n.t("messageVariablesPicker.templates.userName.label"), description: i18n.t("messageVariablesPicker.templates.userName.description") },
    { variable: "{{ticket_id}}", label: i18n.t("messageVariablesPicker.templates.ticketId.label"), description: i18n.t("messageVariablesPicker.templates.ticketId.description") },
    { variable: "{{ms}}", label: i18n.t("messageVariablesPicker.templates.greeting.label"), description: i18n.t("messageVariablesPicker.templates.greeting.description") },
    { variable: "{{hour}}", label: i18n.t("messageVariablesPicker.templates.hour.label"), description: i18n.t("messageVariablesPicker.templates.hour.description") },
    { variable: "{{date}}", label: i18n.t("messageVariablesPicker.templates.date.label"), description: i18n.t("messageVariablesPicker.templates.date.description") },
    { variable: "{{data_hora}}", label: i18n.t("messageVariablesPicker.templates.dateTime.label"), description: i18n.t("messageVariablesPicker.templates.dateTime.description") },
    { variable: "{{queue}}", label: i18n.t("messageVariablesPicker.templates.queue.label"), description: i18n.t("messageVariablesPicker.templates.queue.description") },
    { variable: "{{connection}}", label: i18n.t("messageVariablesPicker.templates.connection.label"), description: i18n.t("messageVariablesPicker.templates.connection.description") },
    { variable: "{{protocol}}", label: i18n.t("messageVariablesPicker.templates.protocol.label"), description: i18n.t("messageVariablesPicker.templates.protocol.description") },
    { variable: "{{name_company}}", label: i18n.t("messageVariablesPicker.templates.companyName.label"), description: i18n.t("messageVariablesPicker.templates.companyName.description") },
  ];

  // Check if text has WhatsApp formatting markers for showing preview
  const hasWhatsAppFormatting = (text) => {
    if (!text) return false;
    return /\*[^\s*].*?\*|_[^\s_].*?_|~[^\s~].*?~|```[\s\S]*?```/.test(text);
  };

  // Build preview HTML from WhatsApp-style markers (only used in preview strip)
  const formatPreviewHtml = (text) => {
    if (!text) return "";
    let html = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    html = html.replace(/```([\s\S]*?)```/g, '<code>$1</code>');
    html = html.replace(/(^|[\s\n])\*([^\s*](?:[^*]*[^\s*])?)\*([\s\n.,!?;:]|$)/g, '$1<b>$2</b>$3');
    html = html.replace(/(^|[\s\n])_([^\s_](?:[^_]*[^\s_])?)_([\s\n.,!?;:]|$)/g, '$1<i>$2</i>$3');
    html = html.replace(/(^|[\s\n])~([^\s~](?:[^~]*[^\s~])?)~([\s\n.,!?;:]|$)/g, '$1<s>$2</s>$3');
    html = html.replace(/\n/g, "<br>");
    return html;
  };

  const handleSelectVariable = (variable) => {
    // Replace the "#..." trigger text with the selected variable
    const cursorPos = inputRef.current?.selectionStart || inputMessage.length;
    const textBefore = inputMessage.substring(0, cursorPos);
    const textAfter = inputMessage.substring(cursorPos);
    const hashIndex = textBefore.lastIndexOf("#");
    if (hashIndex >= 0) {
      const newText = textBefore.substring(0, hashIndex) + variable + textAfter;
      setInputMessage(newText);
    } else {
      setInputMessage(inputMessage + variable);
    }
    setShowVariables(false);
    setVariableFilter("");
    inputRef.current?.focus();
  };

  const typingTimeoutRef = useRef(null);

  const handleChangeInput = (e) => {
    setInputMessage(e.target.value);

    // Enviar typing para WhatsApp (debounce de 800ms entre emits)
    if (e.target.value.length > 0) {
      if (!typingTimeoutRef.current) {
        api.post(`/typing/${ticketId}`).catch(() => {});
        typingTimeoutRef.current = setTimeout(() => {
          typingTimeoutRef.current = null;
        }, 800);
      }
    }
  };

  const handleResizeStart = (e) => {
    e.preventDefault();
    const startY = e.clientY || e.touches?.[0]?.clientY;
    const startHeight = inputHeight;
    const maxH = window.innerHeight * 0.8;
    const onMove = (ev) => {
      const y = ev.clientY || ev.touches?.[0]?.clientY;
      const diff = startY - y;
      const newH = Math.max(90, Math.min(maxH, startHeight + diff));
      setInputHeight(newH);
    };
    const onUp = () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      document.removeEventListener("touchmove", onMove);
      document.removeEventListener("touchend", onUp);
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    document.addEventListener("touchmove", onMove);
    document.addEventListener("touchend", onUp);
  };

  const handleFormatText = (prefix, suffix, mode) => {
    const input = inputRef.current;
    if (!input) return;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    if (start === end) return;
    const selected = inputMessage.substring(start, end);
    const before = inputMessage.substring(0, start);
    const after = inputMessage.substring(end);
    let newText;
    let cursorEnd;

    if (mode === "line-number") {
      const lines = selected.split("\n");
      const formatted = lines.map((line, i) => (line.trim() ? `${i + 1}. ${line}` : line)).join("\n");
      newText = before + formatted + after;
      cursorEnd = start + formatted.length;
    } else if (mode === "line-bullet") {
      const lines = selected.split("\n");
      const formatted = lines.map((line) => (line.trim() ? `• ${line}` : line)).join("\n");
      newText = before + formatted + after;
      cursorEnd = start + formatted.length;
    } else if (mode === "line-quote") {
      const lines = selected.split("\n");
      const formatted = lines.map((line) => (line.trim() ? `> ${line}` : line)).join("\n");
      newText = before + formatted + after;
      cursorEnd = start + formatted.length;
    } else {
      newText = before + prefix + selected + (suffix || prefix) + after;
      cursorEnd = end + prefix.length;
    }

    setInputMessage(newText);
    setFormatToolbarPos(null);
    setTimeout(() => {
      input.focus();
      input.setSelectionRange(start, cursorEnd);
    }, 0);
  };

  // Helper: get caret XY position inside a textarea using a mirror div
  const getCaretCoordinates = (textarea, position) => {
    const mirror = document.createElement("div");
    const style = window.getComputedStyle(textarea);
    // Copy relevant styles
    [
      "fontFamily", "fontSize", "fontWeight", "lineHeight", "letterSpacing",
      "wordSpacing", "textIndent", "whiteSpace", "wordWrap", "overflowWrap",
      "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
      "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth",
      "boxSizing", "width",
    ].forEach((prop) => { mirror.style[prop] = style[prop]; });
    mirror.style.position = "absolute";
    mirror.style.visibility = "hidden";
    mirror.style.overflow = "hidden";
    mirror.style.height = "auto";
    document.body.appendChild(mirror);

    const text = textarea.value.substring(0, position);
    mirror.textContent = text;
    // Add a span to measure position
    const span = document.createElement("span");
    span.textContent = textarea.value.substring(position) || ".";
    mirror.appendChild(span);

    const coords = {
      top: span.offsetTop - textarea.scrollTop,
      left: span.offsetLeft,
    };
    document.body.removeChild(mirror);
    return coords;
  };

  const handleTextSelect = () => {
    const input = inputRef.current;
    if (!input) return;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    if (start !== end && end - start > 0) {
      const textarea = input.tagName === "TEXTAREA" ? input : (input.querySelector && input.querySelector("textarea"));
      const wrapperRect = messageInputRef.current?.getBoundingClientRect();
      if (textarea && wrapperRect) {
        const textareaRect = textarea.getBoundingClientRect();
        const coords = getCaretCoordinates(textarea, start);
        setFormatToolbarPos({
          left: (textareaRect.left - wrapperRect.left) + coords.left + 40,
          top: (textareaRect.top - wrapperRect.top) + coords.top,
        });
      } else {
        setFormatToolbarPos({ left: 100, top: -40 });
      }
    } else {
      setFormatToolbarPos(null);
    }
  };

  const handlePrivateMessage = (e) => {
    setPrivateMessage(!privateMessage);
    setPrivateMessageInputVisible(!privateMessageInputVisible);
  };

  const handleButtonModalOpen = () => {
    handleMenuItemClick();
    setButtonModalOpen(true); // Define o estado como true para abrir o modal
  };

  const handleQuickAnswersClick = async (value) => {
    if (value.mediaPath) {
      try {
        const { data } = await axios.get(value.mediaPath, {
          responseType: "blob",
        });

        handleUploadQuickMessageMedia(data, value.value);
        setInputMessage("");
        return;
        //  handleChangeMedias(response)
      } catch (err) {
        toastError(err);
      }
    }

    setInputMessage("");
    setInputMessage(value.value);
    setTypeBar(false);
  };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const [modalCameraOpen, setModalCameraOpen] = useState(false);

  const handleCapture = (imageData) => {
    if (imageData) {
      handleUploadCamera(imageData);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMediasUpload(selectedMedias);
    setUploadCaptions(selectedMedias.map(() => ""));
    setUploadCurrentIndex(0);
    setShowModalMedias(true);
  };

  const handleChangeSign = (e) => {
    getStatusSingMessageLocalstogare();
  };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false)
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  }

  const handleCancelForwardSelection = () => {
    setSelectedMessages([]);
    setShowSelectMessageCheckbox(false);
    setForwardMessageModalOpen(false);
  };

  const getStatusSingMessageLocalstogare = () => {
    const signMessageStorage = JSON.parse(
      localStorage.getItem("persistentSignMessage")
    );
    //si existe uma chave "sendSingMessage"
    if (signMessageStorage !== null) {
      if (signMessageStorage) {
        localStorage.setItem("persistentSignMessage", false);
        setSignMessage(false);
      } else {
        localStorage.setItem("persistentSignMessage", true);
        setSignMessage(true);
      }
    } else {
      localStorage.setItem("persistentSignMessage", false);
      setSignMessage(false);
    }
  };

  const inputLanguageOptions = [
    { code: "pt-BR", flag: "/flags/br.png", name: "Português" },
    { code: "en", flag: "/flags/us.png", name: "English" },
    { code: "es", flag: "/flags/es.png", name: "Español" },
    { code: "tr", flag: "/flags/tr.png", name: "Türkçe" },
    { code: "ar", flag: "/flags/sa.png", name: "العربية" },
  ];

  const getContactFlag = () => {
    const lang = contactLanguage || "pt-BR";
    const opt = inputLanguageOptions.find(l => l.code === lang || l.code.startsWith(lang) || lang.startsWith(l.code.split("-")[0]));
    return opt || inputLanguageOptions[0];
  };

  const handleChangeContactLang = async (langCode) => {
    try {
      if (contactId) {
        await api.put(`/contacts/language/${contactId}`, { language: langCode });
        setContactLanguage(langCode);
      }
    } catch (err) {
      toastError(err);
    }
    setLangAnchorEl(null);
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      const selectedMedias = Array.from(e.clipboardData.files);
      setMediasUpload(selectedMedias);
      setUploadCaptions(selectedMedias.map(() => ""));
      setUploadCurrentIndex(0);
      setShowModalMedias(true);
      return;
    }
    // Convert HTML formatted text back to WhatsApp markers
    const html = e.clipboardData.getData("text/html");
    if (html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      // Convert <strong>/<b> → *text*
      div.querySelectorAll("strong, b").forEach((el) => {
        el.replaceWith(`*${el.textContent}*`);
      });
      // Convert <em>/<i> → _text_
      div.querySelectorAll("em, i").forEach((el) => {
        el.replaceWith(`_${el.textContent}_`);
      });
      // Convert <del>/<s>/<strike> → ~text~
      div.querySelectorAll("del, s, strike").forEach((el) => {
        el.replaceWith(`~${el.textContent}~`);
      });
      // Convert <code> → ```text```
      div.querySelectorAll("code").forEach((el) => {
        el.replaceWith(`\`\`\`${el.textContent}\`\`\``);
      });
      const converted = div.textContent;
      const plain = e.clipboardData.getData("text/plain");
      // Only use converted if HTML actually had formatting tags
      if (converted !== plain) {
        e.preventDefault();
        const input = inputRef.current;
        if (input) {
          const start = input.selectionStart;
          const end = input.selectionEnd;
          const before = inputMessage.substring(0, start);
          const after = inputMessage.substring(end);
          setInputMessage(before + converted + after);
          setTimeout(() => {
            input.focus();
            input.setSelectionRange(start + converted.length, start + converted.length);
          }, 0);
        }
      }
    }
  };

  const handleInputDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files[0]) {
      const selectedMedias = Array.from(e.dataTransfer.files);
      setMediasUpload(selectedMedias);
      setUploadCaptions(selectedMedias.map(() => ""));
      setUploadCurrentIndex(0);
      setShowModalMedias(true);
    }
  };

  const handleUploadMedia = async (mediasUpload) => {
    setLoading(true);
    // e.preventDefault();

    // Certifique-se de que a variável medias esteja preenchida antes de continuar
    if (!mediasUpload.length) {
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("fromMe", true);
    formData.append("isPrivate", privateMessage ? "true" : "false");
    const userName = privateMessage
      ? `${user.name} - ${i18n.t("messageInputResponsive.privateMessage.suffix")}`
      : user.name;

    mediasUpload.forEach((media) => {
      const caption = (signMessage || privateMessage) && media.caption
        ? `> ${userName}\n${media.caption}`
        : media.caption;
      formData.append("body", caption);
      formData.append("medias", media.file);
    });

    try {
      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    setMediasUpload([]);
    setUploadCaptions([]);
    setShowModalMedias(false);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false)
  };

  const handleSendContatcMessage = async (vcard) => {
    setSenVcardModalOpen(false);
    setLoading(true);

    if (isNil(vcard)) {
      setLoading(false);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: null,
      quotedMsg: replyingMessage,
      isPrivate: privateMessage ? "true" : "false",
      vCard: vcard,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
    setEditingMessage(null);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false);
  };

  const handleSendMessage = async () => {

    if (inputMessage.trim() === "") return;
    setLoading(true);

    const userName = privateMessage
      ? `${user.name} - ${i18n.t("messageInputResponsive.privateMessage.suffix")}`
      : user.name;

    const sendMessage = inputMessage.trim();

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: (signMessage || privateMessage) && !editingMessage
        ? `> ${userName}\n${sendMessage}`
        : sendMessage,
      quotedMsg: replyingMessage,
      isPrivate: privateMessage ? "true" : "false",
    };

    try {
      if (editingMessage !== null) {
        await api.post(`/messages/edit/${editingMessage.id}`, message);
      } else {
        await api.post(`/messages/${ticketId}`, message);
      }
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    lastSavedDraftRef.current = "";
    api.put(`/tickets/u/${ticketId}/draft`, { draft: "" }).catch(() => {});
    if (ticketNumericIdRef.current) {
      window.dispatchEvent(new CustomEvent("ticketDraftUpdate", {
        detail: { ticketId: ticketNumericIdRef.current, draft: "" }
      }));
    }
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
    setPrivateMessage(false);
    setEditingMessage(null);
    setPrivateMessageInputVisible(false)
    handleMenuItemClick();
  };

  // ── Audio: cleanup all resources ──
  const cleanupAudioRecording = () => {
    stopRecordingTimer();
    if (animFrameRef.current) { cancelAnimationFrame(animFrameRef.current); animFrameRef.current = null; }
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
      try { mediaRecorderRef.current.stop(); } catch {}
    }
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }
    if (audioCtxRef.current && audioCtxRef.current.state !== "closed") {
      audioCtxRef.current.close().catch(() => {});
    }
    mediaRecorderRef.current = null;
    audioCtxRef.current = null;
    analyserRef.current = null;
    dataArrayRef.current = null;
  };

  // ── Audio: RMS level from time-domain data ──
  const calculateLevel = (dataArray) => {
    let sum = 0;
    for (let i = 0; i < dataArray.length; i++) {
      const n = (dataArray[i] - 128) / 128;
      sum += n * n;
    }
    const rms = Math.sqrt(sum / dataArray.length);
    const gated = Math.max(0, rms - 0.01);
    const amplified = Math.min(1, gated * 7);
    if (amplified > 0.01) hasDetectedSoundRef.current = true;
    return Math.round(3 + amplified * 29);
  };

  // ── Audio: sliding-bar animation loop ──
  const animateBars = (time) => {
    if (!analyserRef.current || !dataArrayRef.current) return;
    if (time - lastBarPushRef.current > 24) {
      analyserRef.current.getByteTimeDomainData(dataArrayRef.current);
      const level = calculateLevel(dataArrayRef.current);
      recordedBarsRef.current = Math.min(recordedBarsRef.current + 1, 250);
      setWaveformBars(prev => [...prev.slice(1), level]);
      lastBarPushRef.current = time;
    }
    animFrameRef.current = requestAnimationFrame(animateBars);
  };

  // ── Audio: start recording ──
  const handleStartRecording = async () => {
    setLoading(true);
    try {
      audioChunksRef.current = [];
      clearPreviewAudioUrl();
      hasDetectedSoundRef.current = false;
      recStartTimeRef.current = Date.now();
      recElapsedRef.current = 0;
      setRecordingElapsed(0);
      recordedBarsRef.current = 0;
      setWaveformBars(Array(220).fill(3));

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioStreamRef.current = stream;

      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioCtx.createMediaStreamSource(stream);
      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 128;
      analyser.smoothingTimeConstant = 0.25;
      source.connect(analyser);
      audioCtxRef.current = audioCtx;
      audioSourceRef.current = source;
      analyserRef.current = analyser;
      dataArrayRef.current = new Uint8Array(analyser.frequencyBinCount);

      let mimeType = "audio/webm";
      if (MediaRecorder.isTypeSupported("audio/ogg;codecs=opus")) {
        mimeType = "audio/ogg;codecs=opus";
      } else if (MediaRecorder.isTypeSupported("audio/webm;codecs=opus")) {
        mimeType = "audio/webm;codecs=opus";
      }

      const recorder = new MediaRecorder(stream, { mimeType });
      recorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };
      recorder.start(200);
      mediaRecorderRef.current = recorder;

      setRecording(true);
      setRecordingPaused(false);
      startRecordingTimer();
      animFrameRef.current = requestAnimationFrame(animateBars);
    } catch (err) {
      console.error("[audio] startRecording failed:", err);
      toastError(err);
      cleanupAudioRecording();
      setRecording(false);
      setRecordingPaused(false);
    } finally {
      setLoading(false);
    }
  };

  // ── Audio: pause / resume ──
  const handleResumeRecording = () => {
    const recorder = mediaRecorderRef.current;
    if (!recorder || recorder.state !== "paused") {
      return;
    }

    try {
      stopPreview();
      recorder.resume();
      clearPreviewAudioUrl();
      recStartTimeRef.current = Date.now();
      setRecordingPaused(false);
      startRecordingTimer();
      animFrameRef.current = requestAnimationFrame(animateBars);
    } catch (e) {
      console.error("[audio] resumeRecording failed:", e);
    }
  };

  const handlePauseRecording = () => {
    if (recordingPaused) {
      handleResumeRecording();
    } else {
      // Pausa de verdade e gera uma prévia para escutar sem perder a gravação.
      recElapsedRef.current += Date.now() - recStartTimeRef.current;
      stopRecordingTimer();
      const recorder = mediaRecorderRef.current;
      if (!recorder || recorder.state !== "recording") { setRecordingPaused(true); return; }
      if (animFrameRef.current) { cancelAnimationFrame(animFrameRef.current); animFrameRef.current = null; }
      try {
        recorder.requestData();
        recorder.pause();
        setTimeout(() => {
          const blob = new Blob(audioChunksRef.current, { type: recorder.mimeType || "audio/webm" });
          updatePreviewAudioUrl(blob);
          setPreviewPlaying(false);
        }, 150);
      } catch (e) {
        console.error("[audio] pauseRecording failed:", e);
      }
      setRecordingPaused(true);
    }
  };

  const resetBarColors = () => {
    const wrapper = barsWrapperRef.current;
    if (!wrapper) return;
    const bars = wrapper.children;
    for (let i = 0; i < bars.length; i++) {
      bars[i].style.backgroundColor = "";
    }
  };

  const stopPreview = () => {
    if (previewAnimRef.current) { cancelAnimationFrame(previewAnimRef.current); previewAnimRef.current = null; }
    if (previewAudioRef.current) {
      previewAudioRef.current.onended = null;
      previewAudioRef.current.onplay = null;
      previewAudioRef.current.pause();
      previewAudioRef.current = null;
    }
    if (previewBallRef.current) { previewBallRef.current.style.left = "0"; previewBallRef.current.style.display = "none"; }
    setPreviewPlaying(false);
    setPreviewTime(0);
  };

  const handlePreviewPlayback = () => {
    if (!previewAudioUrl) return;

    if (previewPlaying && previewAudioRef.current) {
      previewAudioRef.current.pause();
      setPreviewPlaying(false);
      return;
    }

    if (!previewAudioRef.current) {
      const audio = new Audio(previewAudioUrl);
      audio.onended = () => {
        setPreviewPlaying(false);
        previewAudioRef.current = null;
      };
      previewAudioRef.current = audio;
    }

    const play = previewAudioRef.current.play();
    if (play && typeof play.catch === "function") {
      play.catch(() => setPreviewPlaying(false));
    }
    setPreviewPlaying(true);
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const messages = await listQuickMessages({ companyId, userId: user.id });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 90) {
          truncatedMessage = m.message.substring(0, 90) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
        };
      });
      if (isMounted.current) {

        setQuickAnswer(options);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length >= 1
    ) {
      const firstWord = inputMessage.charAt(0);

      if (firstWord === "/") {
        if (!quickDrawerOpen) {
          setQuickDrawerOpen(true);
          setQuickDrawerSearch(inputMessage.substring(1));
          setQuickDrawerExpanded(null);
        }
        setTypeBar(false);
      } else {
        setTypeBar(false);
      }

      // Detect # for variable insertion
      const cursorPos = inputRef.current?.selectionStart || inputMessage.length;
      const textBeforeCursor = inputMessage.substring(0, cursorPos);
      const hashMatch = textBeforeCursor.match(/#([a-zA-Z_{}]*)$/);
      if (hashMatch) {
        const filter = hashMatch[1].toLowerCase();
        setVariableFilter(filter);
        setShowVariables(true);
      } else {
        setShowVariables(false);
        setVariableFilter("");
      }
    } else {
      setTypeBar(false);
      setShowVariables(false);
      setVariableFilter("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage]);

  const disableOption = () => {
    return (
      loading ||
      recording ||
      (ticketStatus !== "open" && ticketStatus !== "group")
    );
  };

  const handleUploadCamera = async (blob) => {
    setLoading(true);
    try {
      const formData = new FormData();
      const filename = `${new Date().getTime()}.png`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d` : "");
      formData.append("fromMe", true);

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
    setLoading(false);
  };

  const handleUploadQuickMessageMedia = async (blob, message) => {
    setLoading(true);
    try {
      const extension = blob.type.split("/")[1];

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension}`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d${message}` : message);
      formData.append("fromMe", true);

      if (isMounted.current) {
        await api.post(`/messages/${ticketId}`, formData);
      }
      clearPreviewAudioUrl();
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };


  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const recorder = mediaRecorderRef.current;
      const blob = await new Promise((resolve) => {
        if (!recorder || recorder.state === "inactive") {
          resolve(new Blob(audioChunksRef.current, { type: "audio/webm" }));
          return;
        }
        recorder.onstop = () => {
          resolve(new Blob(audioChunksRef.current, { type: recorder.mimeType || "audio/webm" }));
        };
        try {
          if (recorder.state === "paused") recorder.resume();
          recorder.requestData();
          recorder.stop();
        } catch {
          resolve(new Blob(audioChunksRef.current, { type: recorder.mimeType || "audio/webm" }));
        }
      });
      cleanupAudioRecording();

      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        setRecordingPaused(false);
        setRecordingElapsed(0);
        setWaveformBars(Array(220).fill(3));
        return;
      }

      const formData = new FormData();
      const ext = blob.type.includes("mp4") ? "m4a" : blob.type.includes("ogg") ? "ogg" : "webm";
      const filename = `${new Date().getTime()}.${ext}`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);

      if (isMounted.current) {
        await api.post(`/messages/${ticketId}`, formData);
      }
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
        setRecording(false);
        setRecordingPaused(false);
        setRecordingElapsed(0);
        setWaveformBars(Array(220).fill(3));
      }
    }
  };

  const handleCloseModalMedias = () => {
    setShowModalMedias(false);
  };
  const handleCancelAudio = () => {
    cleanupAudioRecording();
    clearPreviewAudioUrl();
    setRecording(false);
    setRecordingPaused(false);
    setRecordingElapsed(0);
    setWaveformBars(Array(220).fill(3));
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const handleSendContactModalOpen = async () => {
    handleMenuItemClick();
    setSenVcardModalOpen(true);
  };

  const handleCameraModalOpen = async () => {
    handleMenuItemClick();
    setModalCameraOpen(true);
  };

  const handleCancelSelection = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
    setUploadCaptions([]);
    setUploadCurrentIndex(0);
  };

  const getReplyDocIconSrc = (ext) => {
    const lower = (ext || "").toLowerCase();
    if (lower === "pdf") return "/imagens/PDF.png";
    if (["doc", "docx"].includes(lower)) return "/imagens/word.png";
    if (["xls", "xlsx", "csv"].includes(lower)) return "/imagens/excel.png";
    if (lower === "txt") return "/imagens/txt.png";
    return "/imagens/doc.png";
  };

  const getReplyFileExt = (url, body) => {
    if (!url && !body) return "";
    const source = url || body || "";
    const parts = source.split(".");
    if (parts.length > 1) {
      const ext = parts.pop().split(/[?#]/)[0];
      if (ext && ext.length <= 5 && /^[a-zA-Z0-9]+$/.test(ext)) return ext.toLowerCase();
    }
    return "";
  };

  const isDocType = (mediaType) => {
    return mediaType && mediaType !== "image" && mediaType !== "video" && mediaType !== "audio";
  };

  const formatReplyDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    const day = d.getDate();
    const months = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
    return `${day} de ${months[d.getMonth()]}`;
  };

  const renderReplyingMessage = (message) => {
    const ext = getReplyFileExt(message.mediaUrl, message.body);
    const isDoc = isDocType(message.mediaType);
    const fileName = message.body || message.mediaUrl?.split("/").pop() || "Documento";
    const sender = message.fromMe ? i18n.t("messagesInput.you") : (message.contact?.name || i18n.t("messagesInput.contact"));
    const dateStr = formatReplyDate(message.createdAt);
    const nameClass = message.fromMe ? classes.replyginSenderName : classes.replyginSenderNameContact;

    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={message.fromMe ? classes.replyginSelfMsgSideColor : classes.replyginContactMsgSideColor}
          ></span>
          <div className={classes.replyginMsgBody}>
            {isDoc && message.mediaUrl ? (
              <>
                <img
                  src={getReplyDocIconSrc(ext)}
                  alt={ext.toUpperCase()}
                  className={classes.replyginDocIcon}
                />
                <div className={classes.replyginDocInfo}>
                  <div className={nameClass}>{sender}</div>
                  <div className={classes.replyginDocName}>{fileName}</div>
                  <div className={classes.replyginDocMeta}>
                    {ext ? ext.toUpperCase() : "DOC"} | {dateStr}
                  </div>
                </div>
              </>
            ) : message.mediaType === "image" && message.mediaUrl ? (
              <>
                <img
                  src={message.mediaUrl}
                  alt="img"
                  style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 6, flexShrink: 0 }}
                />
                <div className={classes.replyginDocInfo}>
                  <div className={nameClass}>{sender}</div>
                  <div className={classes.replyginDocName}>{(message.body || "").replace(/^>\s?\S+[\n\s]/, "") || "Foto"}</div>
                  <div className={classes.replyginDocMeta}>
                    Imagem | {dateStr}
                  </div>
                </div>
              </>
            ) : message.mediaType === "video" && message.mediaUrl ? (
              <>
                <div style={{ width: 40, height: 40, borderRadius: 6, flexShrink: 0, background: "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ color: "#fff", fontSize: 16 }}>&#9654;</span>
                </div>
                <div className={classes.replyginDocInfo}>
                  <div className={nameClass}>{sender}</div>
                  <div className={classes.replyginDocName}>{(message.body || "").replace(/^>\s?\S+[\n\s]/, "") || i18n.t("messagesInput.videoFallback")}</div>
                  <div className={classes.replyginDocMeta}>
                    {i18n.t("messagesInput.videoFallback")} | {dateStr}
                  </div>
                </div>
              </>
            ) : (
              <div className={classes.replyginDocInfo}>
                <div className={nameClass}>{sender}</div>
                <div style={{ overflow: "hidden", wordBreak: "break-word", whiteSpace: "pre-wrap", display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical" }}>{(message.body || "").replace(/^>\s?\S+[\n\s]/, "")}</div>
              </div>
            )}
          </div>
        </div>
        <button
          className={classes.replyginCloseBtn}
          onClick={() => {
            setReplyingMessage(null);
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <IconCircleX size={20} strokeWidth={1.5} />
        </button>
      </div>
    );
  };

  const getUploadIconSrc = (file) => {
    if (!file) return "/imagens/doc.png";
    const ext = file.name?.split(".").pop()?.toLowerCase() || "";
    if (ext === "pdf") return "/imagens/PDF.png";
    if (["doc", "docx"].includes(ext)) return "/imagens/word.png";
    if (["xls", "xlsx", "csv"].includes(ext)) return "/imagens/excel.png";
    if (ext === "txt") return "/imagens/txt.png";
    return "/imagens/doc.png";
  };

  const formatUploadSize = (bytes) => {
    if (!bytes) return "";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const [uploadCaptions, setUploadCaptions] = useState([]);
  const [uploadCurrentIndex, setUploadCurrentIndex] = useState(0);

  const handleInlineSend = () => {
    const selectedMedias = mediasUpload.map((file, idx) => ({
      file,
      caption: uploadCaptions[idx] || "",
    }));
    handleUploadMedia(selectedMedias);
    setUploadCaptions([]);
    setUploadCurrentIndex(0);
  };

  const mediaPreviewVisible = mediasUpload.length > 0 && showModalMedias;
  const currentFile = mediaPreviewVisible ? (mediasUpload[uploadCurrentIndex] || mediasUpload[0]) : null;
  const currentUploadCaption = uploadCaptions[uploadCurrentIndex] || "";
  const currentFileIsImage = currentFile?.type?.startsWith("image");
  const currentFileIsVideo = currentFile?.type?.startsWith("video");
  const currentFileIsPdf = currentFile?.type === "application/pdf";
  const currentFileExt = currentFile?.name?.split(".").pop()?.toLowerCase() || "";
  const currentFileSize = currentFile ? formatUploadSize(currentFile?.size) : "";

  {
    return (
      <div style={mediaPreviewVisible ? { display: "flex", flexDirection: "column", height: "100%", width: "100%" } : {}}>
        {/* Media preview — glassmorphism card above the input */}
        {mediaPreviewVisible && (
          <div style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "16px 18px",
            overflow: "hidden",
          }}>
            {/* Glass card */}
            <div style={{
              width: "100%",
              maxWidth: "100%",
              display: "flex",
              flexDirection: "column",
              background: theme.mode === "light"
                ? "rgba(255, 255, 255, 0.45)"
                : "rgba(30, 40, 50, 0.55)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              borderRadius: 18,
              border: theme.mode === "light"
                ? "1px solid rgba(255,255,255,0.6)"
                : "1px solid rgba(255,255,255,0.1)",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
              overflow: "hidden",
              margin: 0,
            }}>
              {/* Image / file preview */}
              <div style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px 20px 12px",
                minHeight: 0,
              }}>
                {currentFileIsImage ? (
                  <img
                    src={URL.createObjectURL(currentFile)}
                    alt={currentFile.name}
                    style={{ maxWidth: "100%", maxHeight: "calc(100% - 20px)", objectFit: "contain", borderRadius: 12 }}
                  />
                ) : currentFileIsVideo ? (
                  <video
                    src={URL.createObjectURL(currentFile)}
                    controls
                    style={{ maxWidth: "100%", maxHeight: "calc(100% - 20px)", borderRadius: 12 }}
                  />
                ) : currentFileIsPdf ? (
                  <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden", maxHeight: "50vh" }}>
                    <Document file={URL.createObjectURL(currentFile)} onLoadSuccess={({ numPages }) => {}}>
                      <Page pageNumber={1} width={340} />
                    </Document>
                  </div>
                ) : (
                  <img src={getUploadIconSrc(currentFile)} alt={currentFileExt} style={{ width: 72, height: 72, objectFit: "contain" }} />
                )}
              </div>
              {/* File info */}
              <div style={{ textAlign: "center", padding: "0 20px 10px" }}>
                <div style={{ fontSize: 13, fontWeight: 500, color: theme.mode === "light" ? "#3b7ddd" : "#7db8f0" }}>{currentFile.name}</div>
                <div style={{ fontSize: 11, color: theme.mode === "light" ? "#8696a0" : "#8696a0", marginTop: 2 }}>
                  {currentFileSize || ""}
                </div>
              </div>
              {/* Thumbnails — fixed at bottom of card */}
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "14px 16px 14px",
                overflow: "visible",
                borderTop: theme.mode === "light"
                  ? "1px solid rgba(0,0,0,0.06)"
                  : "1px solid rgba(255,255,255,0.08)",
              }}>
                {mediasUpload.map((file, idx) => {
                  const isImg = file.type?.startsWith("image");
                  return (
                    <div
                      key={idx}
                      onClick={() => setUploadCurrentIndex(idx)}
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: 8,
                        border: idx === uploadCurrentIndex ? "2px solid #8b5cf6" : "2px solid transparent",
                        cursor: "pointer",
                        background: theme.mode === "light" ? "#f0f0f0" : "#2a3a4a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        flexShrink: 0,
                      }}
                    >
                      {isImg ? (
                        <img src={URL.createObjectURL(file)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 6, overflow: "hidden" }} />
                      ) : (
                        <img src={getUploadIconSrc(file)} alt="" style={{ width: 28, height: 28, objectFit: "contain" }} />
                      )}
                      {idx === uploadCurrentIndex && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            const newFiles = [...mediasUpload];
                            newFiles.splice(idx, 1);
                            setMediasUpload(newFiles);
                            setUploadCaptions((prev) => {
                              const next = [...prev];
                              next.splice(idx, 1);
                              return next;
                            });
                            if (uploadCurrentIndex >= newFiles.length) setUploadCurrentIndex(Math.max(0, newFiles.length - 1));
                            if (newFiles.length === 0) { setShowModalMedias(false); }
                          }}
                          style={{ position: "absolute", top: -9, right: -9, width: 22, height: 22, padding: 0, borderRadius: "50%", background: theme.mode === "light" ? "#ffffff" : "#26343d", color: theme.mode === "light" ? "#ef4444" : "#f87171", border: theme.mode === "light" ? "1px solid rgba(239,68,68,0.25)" : "1px solid rgba(248,113,113,0.25)", boxShadow: "0 2px 6px rgba(0,0,0,0.22)", zIndex: 2 }}
                        >
                          <Clear size={14} strokeWidth={2.2} />
                        </IconButton>
                      )}
                    </div>
                  );
                })}
                <label style={{
                  width: 48, height: 48, borderRadius: 8, border: theme.mode === "light" ? "2px dashed #ccc" : "2px dashed #555", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: theme.mode === "light" ? "#999" : "#777", flexShrink: 0, lineHeight: 0, boxSizing: "border-box",
                }}>
                  <IconAdd size={22} strokeWidth={1.8} />
                  <input type="file" multiple style={{ display: "none" }} onChange={(e) => {
                    if (e.target.files?.length) {
                      const newFiles = Array.from(e.target.files);
                      setMediasUpload(prev => [...prev, ...newFiles]);
                      setUploadCaptions(prev => [...prev, ...newFiles.map(() => "")]);
                    }
                  }} />
                </label>
              </div>
              {/* Caption input + action buttons */}
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 16px 12px",
                borderTop: theme.mode === "light"
                  ? "1px solid rgba(0,0,0,0.06)"
                  : "1px solid rgba(255,255,255,0.08)",
              }}>
                <IconButton
                  size="small"
                  onClick={() => { setMediasUpload([]); setShowModalMedias(false); setUploadCaptions([]); setUploadCurrentIndex(0); }}
                  style={{ color: theme.mode === "light" ? "#999" : "#777" }}
                >
                  <Clear size={20} />
                </IconButton>
                <InputBase
                  placeholder={i18n.t("messageInput.placeholderCaption") || "Adicionar legenda..."}
                  value={currentUploadCaption}
                  onChange={(e) => {
                    const value = e.target.value;
                    setUploadCaptions((prev) => {
                      const next = [...prev];
                      next[uploadCurrentIndex] = value;
                      return next;
                    });
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleInlineSend();
                    }
                  }}
                  style={{
                    flex: 1,
                    fontSize: 14,
                    padding: "6px 12px",
                    borderRadius: 20,
                    background: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.08)",
                    color: theme.mode === "light" ? "#333" : "#eee",
                  }}
                  multiline
                  maxRows={3}
                />
                <IconButton
                  onClick={handleInlineSend}
                  disabled={loading}
                  style={{
                    backgroundColor: "#0b7dda",
                    color: "#fff",
                    width: 36,
                    height: 36,
                  }}
                >
                  {loading ? (
                    <CircularProgress size={18} style={{ color: "#fff" }} />
                  ) : (
                    <IconSend color="#fff" size={18} />
                  )}
                </IconButton>
              </div>
            </div>
          </div>
        )}
        {modalCameraOpen && (
          <CameraModal
            isOpen={modalCameraOpen}
            onRequestClose={() => setModalCameraOpen(false)}
            onCapture={handleCapture}
          />
        )}
        {senVcardModalOpen && (
          <ContactSendModal
            modalOpen={senVcardModalOpen}
            onClose={(c) => {
              handleSendContatcMessage(c);
            }}
          />
        )}
        <Paper
          ref={messageInputRef}
          square
          elevation={0}
          className={classes.mainWrapper}
          style={{ backgroundColor: "transparent" }}
          onDragEnter={() => setOnDragEnter(true)}
          onDrop={(e) => handleInputDrop(e)}
        >
          {/* File inputs FORA do popover para não serem destruídos no iOS ao fechar o menu */}
          <input multiple type="file" id="upload-img-button" accept="image/*,video/*" className={classes.uploadInput} onChange={handleChangeMedias} />
          <input type="file" id="upload-cam-button" accept="image/*" capture="environment" className={classes.uploadInput} onChange={handleChangeMedias} />
          <input multiple type="file" id="upload-doc-button" accept="application/*,text/*" className={classes.uploadInput} onChange={handleChangeMedias} />
          {/* Upload menu (shared between desktop and mobile) */}
          <ChatiaPopover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleMenuItemClick}
            title={i18n.t("messageInput.type.title") || "Anexar"}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <label htmlFor="upload-img-button" onClick={handleMenuItemClick} style={{ display: "block" }}>
              <PopoverOptionItem
                icon={<IconImage size={20} strokeWidth={1.5} />}
                label={i18n.t("messageInput.type.imageVideo")}
              />
            </label>
            <label htmlFor="upload-cam-button" onClick={handleMenuItemClick} style={{ display: "block" }}>
              <PopoverOptionItem
                icon={<IconCamera size={20} strokeWidth={1.5} />}
                label={i18n.t("messageInput.type.cam")}
              />
            </label>
            <label htmlFor="upload-doc-button" onClick={handleMenuItemClick} style={{ display: "block" }}>
              <PopoverOptionItem
                icon={<IconFileUp size={20} strokeWidth={1.5} />}
                label={i18n.t("messageInputResponsive.type.document")}
              />
            </label>
            <PopoverOptionItem
              icon={<IconUserRound size={20} strokeWidth={1.5} />}
              label={i18n.t("messageInput.type.contact")}
              onClick={handleSendContactModalOpen}
            />
          </ChatiaPopover>
          {buttonModalOpen && (
            <ButtonModal
              modalOpen={buttonModalOpen}
              onClose={() => setButtonModalOpen(false)}
              ticketId={ticketId}
            />
          )}
          {/* Language popover */}
          <ChatiaPopover
            open={Boolean(langAnchorEl)}
            anchorEl={langAnchorEl}
            onClose={() => setLangAnchorEl(null)}
            title={i18n.t("messageInput.selectLanguage") || "Selecione o idioma"}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            {inputLanguageOptions.map((lang) => {
              const cLang = contactLanguage || "pt-BR";
              const selected = cLang === lang.code ||
                cLang.startsWith(lang.code.split("-")[0]) ||
                lang.code.startsWith(cLang.split("-")[0]);
              return (
                <PopoverOptionItem
                  key={lang.code}
                  icon={lang.flag}
                  label={lang.name}
                  selected={selected}
                  onClick={() => handleChangeContactLang(lang.code)}
                />
              );
            })}
          </ChatiaPopover>
          {/* AI Config Dialog */}
          <ChatiaDialog
            open={aiConfigOpen}
            onClose={() => setAiConfigOpen(false)}
            title={i18n.t("messagesInput.aiSuggestion.configTitle")}
            maxWidth="sm"
            onSave={handleSaveAiPrompt}
            saveText={savingAiPrompt ? i18n.t("messagesInput.aiSuggestion.saving") : i18n.t("messagesInput.aiSuggestion.save")}
            saveDisabled={savingAiPrompt}
            saveType="button"
          >
            <ChatiaPromptField
              label={i18n.t("messagesInput.aiSuggestion.promptLabel")}
              placeholder={i18n.t("messagesInput.aiSuggestion.promptPlaceholder")}
              value={aiPromptDraft}
              onChange={(e) => setAiPromptDraft(e.target.value)}
              helperText={i18n.t("messagesInput.aiSuggestion.promptHelper")}
              rows={6}
            />
          </ChatiaDialog>
          {/* ========== WHATSAPP-STYLE INPUT ROW ========== */}
          {!mediaPreviewVisible && (
          <div className={classes.newMessageBox}>
            {/* ===== AUDIO RECORDER BAR (replaces input when recording) ===== */}
            {recording && (
              <div className={clsx(classes.audioRecorderBar, recordingPaused && classes.audioRecorderBarPaused)}>
                <IconButton className={classes.audioRecDeleteBtn} onClick={handleCancelAudio} disabled={loading} size="small">
                  <IconTrash size={20} strokeWidth={1.5} />
                </IconButton>
                {recordingPaused && previewAudioUrl ? (
                  <div className={classes.audioRecPreview}>
                    <audio
                      className={classes.audioRecNativePreview}
                      src={previewAudioUrl}
                      controls
                      preload="metadata"
                    />
                  </div>
                ) : null}
                {recordingPaused && previewAudioUrl ? null : (
                  <>
                    <div className={classes.audioRecDot} />
                    <span className={classes.audioRecTimer}>
                      {formatRecordingTime(recordingElapsed)}
                    </span>
                  </>
                )}
                <div
                  className={clsx(classes.audioRecWaveform, recordingPaused && classes.audioRecHiddenWaveform)}
                  ref={waveformContainerRef}
                >
                  <div ref={barsWrapperRef} style={{ display: "flex", alignItems: "center", gap: 2, height: "100%" }}>
                    {waveformBars.map((height, index) => (
                      <span
                        key={index}
                        className={clsx(classes.audioRecWaveBar, height > 4 && classes.audioRecWaveBarActive)}
                        style={{ height }}
                      />
                    ))}
                  </div>
                </div>
                {recordingPaused ? (
                  <>
                    <IconButton
                      className={classes.audioRecResumeBtn}
                      onClick={handleResumeRecording}
                      disabled={loading}
                      size="small"
                      title="Continuar gravando"
                      aria-label="Continuar gravando"
                    >
                      <IconMic size={22} strokeWidth={1.5} />
                    </IconButton>
                  </>
                ) : (
                  /* Pause button */
                  <IconButton className={classes.audioRecPauseBtn} onClick={handlePauseRecording} disabled={loading} size="small">
                    <IconPause size={22} strokeWidth={1.5} />
                  </IconButton>
                )}
                <IconButton className={classes.audioRecSendBtn} onClick={handleUploadAudio} disabled={loading}>
                  {loading ? (
                    <CircularProgress size={20} style={{ color: "#0b7dda" }} />
                  ) : (
                    <IconSend size={22} strokeWidth={1.5} />
                  )}
                </IconButton>
              </div>
            )}
            {/* ===== INPUT PILL ===== */}
            <div
              className={privateMessageInputVisible ? classes.messageInputWrapperPrivate : classes.messageInputWrapper}
              style={{ minHeight: inputHeight, display: recording ? "none" : undefined }}
            >
              {/* Resize handle (top center, visible on hover) */}
              <div
                className={classes.resizeHandle}
                onMouseDown={handleResizeStart}
                onTouchStart={handleResizeStart}
              />
              {(replyingMessage && renderReplyingMessage(replyingMessage)) || (editingMessage && renderReplyingMessage(editingMessage))}

              {/* Variables inline (same level as reply) */}
              {showVariables && (
                <ClickAwayListener onClickAway={() => setShowVariables(false)}>
                  <div className={classes.variablesWrapper}>
                    <div className={classes.variablesHeader}>
                      <span className={classes.variablesTitle}>
                        {i18n.t("messageInput.variables") || "Variáveis"}
                      </span>
                    </div>
                    {TEMPLATE_VARIABLES
                      .filter(v =>
                        !variableFilter ||
                        v.label.toLowerCase().includes(variableFilter) ||
                        v.variable.toLowerCase().includes(variableFilter) ||
                        v.description.toLowerCase().includes(variableFilter)
                      )
                      .map((v, idx) => (
                        <div
                          key={idx}
                          className={classes.variableItem}
                          onClick={() => handleSelectVariable(v.variable)}
                        >
                          <span className={classes.variableCode}>{v.variable}</span>
                          <span className={classes.variableLabel}>{v.label}</span>
                          <span className={classes.variableDesc}>{v.description}</span>
                        </div>
                      ))}
                  </div>
                </ClickAwayListener>
              )}

              {showEmoji ? (
                <div className={classes.emojiBox}>
                  <ClickAwayListener onClickAway={(e) => setShowEmoji(true)}>
                    <Picker
                      perLine={16}
                      theme={theme.mode === "light" ? "light" : "dark"}
                      i18n={{
                        search: i18n.t("emoji.search") || "Pesquisar",
                        notfound: i18n.t("emoji.notfound") || "Nenhum emoji encontrado",
                        categories: {
                          search: i18n.t("emoji.categories.search") || "Resultados",
                          recent: i18n.t("emoji.categories.recent") || "Recentes",
                          smileys: i18n.t("emoji.categories.smileys") || "Rostos e Emoções",
                          people: i18n.t("emoji.categories.people") || "Pessoas",
                          nature: i18n.t("emoji.categories.nature") || "Animais e Natureza",
                          foods: i18n.t("emoji.categories.foods") || "Comidas e Bebidas",
                          activity: i18n.t("emoji.categories.activity") || "Atividades",
                          places: i18n.t("emoji.categories.places") || "Viagens e Lugares",
                          objects: i18n.t("emoji.categories.objects") || "Objetos",
                          symbols: i18n.t("emoji.categories.symbols") || "Símbolos",
                          flags: i18n.t("emoji.categories.flags") || "Bandeiras",
                          custom: i18n.t("emoji.categories.custom") || "Personalizados",
                        },
                      }}
                      showPreview={true}
                      showSkinTones={false}
                      onSelect={handleAddEmoji}
                    />
                  </ClickAwayListener>
                </div>
              ) : null}

              {/* Format toolbar (appears on text selection, above selected text) */}
              {formatToolbarPos && (
                <div
                  className={classes.formatToolbar}
                  style={{
                    left: Math.max(0, formatToolbarPos.left - 100),
                    top: formatToolbarPos.top - 54,
                  }}
                >
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText("*"); }} title={i18n.t("messagesInput.format.bold")}>
                    <span style={{ fontWeight: 700, fontSize: 15 }}>B</span>
                  </IconButton>
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText("_"); }} title={i18n.t("messagesInput.format.italic")}>
                    <span style={{ fontStyle: "italic", fontSize: 15 }}>I</span>
                  </IconButton>
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText("~"); }} title={i18n.t("messagesInput.format.strikethrough")}>
                    <span style={{ textDecoration: "line-through", fontSize: 15 }}>S</span>
                  </IconButton>
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText("```"); }} title={i18n.t("messagesInput.format.code")}>
                    <span style={{ fontFamily: "monospace", fontSize: 14 }}>&lt;/&gt;</span>
                  </IconButton>
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText(null, null, "line-number"); }} title={i18n.t("messagesInput.format.numberedList")}>
                    <span style={{ fontSize: 16, fontWeight: 600, fontFamily: "monospace" }}>1.</span>
                  </IconButton>
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText(null, null, "line-bullet"); }} title={i18n.t("messagesInput.format.bulletList")}>
                    <span style={{ fontSize: 18, fontWeight: 700 }}>•</span>
                  </IconButton>
                  <IconButton className={classes.formatBtn} onMouseDown={(e) => { e.preventDefault(); handleFormatText(null, null, "line-quote"); }} title={i18n.t("messagesInput.format.quote")}>
                    <span style={{ fontSize: 18, fontWeight: 700 }}>»</span>
                  </IconButton>
                </div>
              )}

              {/* Text input - full width on top */}
              <InputBase
                inputRef={(input) => {
                  input && input.focus();
                  input && (inputRef.current = input);
                }}
                className={privateMessageInputVisible ? classes.messageInputPrivate : classes.messageInput}
                placeholder={
                  privateMessageInputVisible
                    ? (ticketStatus === "open" || ticketStatus === "group"
                        ? i18n.t("messagesInput.placeholderPrivateMessage")
                        : i18n.t("messagesInput.placeholderClosed"))
                    : placeholderText
                }
                multiline
                value={inputMessage}
                onChange={handleChangeInput}
                disabled={disableOption()}
                onSelect={handleTextSelect}
                onPaste={(e) => {
                  (ticketStatus === "open" || ticketStatus === "group") &&
                    handleInputPaste(e);
                }}
                onKeyPress={(e) => {
                  if (loading) return;
                  if (e.key === "Enter") {
                    if (enterSends && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }
                }}
              />
              {/* WhatsApp-style format preview - only shows when text has formatting markers */}
              {hasWhatsAppFormatting(inputMessage) && (
                <div
                  className={classes.formatPreview}
                  dangerouslySetInnerHTML={{ __html: formatPreviewHtml(inputMessage) }}
                />
              )}

              {/* AI suggestions popup */}
              {showAiSuggestions && aiSuggestions.length > 0 && (
                <ClickAwayListener onClickAway={() => setShowAiSuggestions(false)}>
                  <div className={classes.aiSuggestionsWrapper}>
                    <div className={classes.aiSuggestionsHeader}>
                      <Typography className={classes.aiSuggestionsTitle}>
                        {i18n.t("messageInput.aiSuggestions") || "Sugestões IA"}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => setShowAiSuggestions(false)}
                        style={{
                          padding: 3,
                          backgroundColor: "rgba(255, 255, 255, 0.08)",
                          color: "#ffffff",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.18)";
                          e.currentTarget.style.color = "#ffffff";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
                          e.currentTarget.style.color = "#ffffff";
                        }}
                      >
                        <Clear size={14} />
                      </IconButton>
                    </div>
                    {aiSuggestions.map((s, idx) => {
                      const badgeColors = {
                        direta: "#2196F3", consultiva: "#4CAF50", curta: "#FF9800",
                        formal: "#673AB7", casual: "#E91E63", expandida: "#009688"
                      };
                      return (
                        <div
                          key={idx}
                          className={classes.aiSuggestionItem}
                          onClick={() => handleSelectAiSuggestion(s.text)}
                        >
                          <span
                            className={classes.aiSuggestionBadge}
                            style={{ background: badgeColors[s.type] || "#6B46C1" }}
                          >
                            {s.type}
                          </span>
                          <span className={classes.aiSuggestionText}>{s.text}</span>
                        </div>
                      );
                    })}
                  </div>
                </ClickAwayListener>
              )}

              {/* Bottom row: left icons + right icons */}
              <div className={classes.inputBottomRow}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* + button */}
                  <IconButton
                    disabled={disableOption()}
                    aria-label="uploadMedias"
                    component="span"
                    onClick={handleOpenMenuClick}
                    className={classes.inputIconBtn}
                  >
                    <IconAdd size={18} color="currentColor" />
                  </IconButton>
                  {/* Emoji button */}
                  <IconButton
                    aria-label="emojiPicker"
                    component="span"
                    disabled={disableOption()}
                    onClick={(e) => setShowEmoji((prevState) => !prevState)}
                    className={classes.inputIconBtn}
                  >
                    <IconEmoji size={20} strokeWidth={1.8} color="currentColor" />
                  </IconButton>
                  {/* Language flag */}
                  <Tooltip title={i18n.t("messageInput.tooltip.language") || "Idioma"}>
                    <div
                      className={classes.langFlagBtn}
                      onClick={(e) => setLangAnchorEl(e.currentTarget)}
                    >
                      <img
                        src={getContactFlag().flag}
                        alt={getContactFlag().name}
                        className={classes.langFlagImg}
                      />
                    </div>
                  </Tooltip>
                  {/* Enter sends toggle */}
                  <Tooltip title={enterSends ? "Enter envia (clique para desativar)" : "Enter pula linha (clique para ativar envio)"}>
                    <div className={classes.enterToggle}>
                      <IconEnter
                        size={16}
                        strokeWidth={1.5}
                        color={theme.mode === 'light' ? "#555" : "#ccc"}
                      />
                      <CustomToggleSwitch
                        className={classes.enterToggleSwitch}
                        checked={enterSends}
                        onChange={(e) => {
                          const next = e.target.checked;
                          setEnterSends(next);
                          try { localStorage.setItem("enterSends", String(next)); } catch {}
                        }}
                      />
                    </div>
                  </Tooltip>
                </div>

                {/* Right-side buttons */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  {!privateMessageInputVisible && (
                    <>
                      {signMessagePar && (
                        <Tooltip title={i18n.t("messageInput.tooltip.signature")}>
                          <IconButton component="span" onClick={handleChangeSign} className={signMessage ? classes.inputIconBtnActive : classes.inputIconBtn}>
                            <Create size={20} />
                          </IconButton>
                        </Tooltip>
                      )}
                      <span className={classes.aiButtonWrapper}>
                        <Tooltip title={i18n.t("messagesInput.aiSuggestion.tooltip")}>
                          <IconButton
                            component="span"
                            disabled={disableOption() || loadingAiSuggestions}
                            onClick={handleAiSuggestions}
                            className={classes.inputIconBtn}
                          >
                            {loadingAiSuggestions ? (
                              <CircularProgress size={18} />
                            ) : (
                              <IconAi size={18} color="currentColor" />
                            )}
                          </IconButton>
                        </Tooltip>
                        <IconButton
                          className={classes.aiConfigBtn}
                          size="small"
                          onClick={handleOpenAiConfig}
                        >
                          <IconAiConfig size={14} color="currentColor" />
                        </IconButton>
                      </span>
                      <Tooltip title={i18n.t("tickets.buttons.quickMessageFlash")}>
                        <IconButton component="span" onClick={() => { setQuickDrawerOpen(true); setQuickDrawerSearch(""); setQuickDrawerExpanded(null); }} className={classes.inputIconBtn}>
                          <IconBolt size={18} color="currentColor" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                        <IconButton component="span" onClick={() => setAppointmentModalOpen(true)} disabled={loading} className={classes.inputIconBtn}>
                          <IconSchedule size={18} color="currentColor" />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                  <Tooltip title={i18n.t("messageInput.tooltip.privateMessage")}>
                    <IconButton component="span" onClick={handlePrivateMessage} className={privateMessage ? classes.inputIconBtnActive : classes.inputIconBtn}>
                      <IconPrivateMsg size={18} color="currentColor" />
                    </IconButton>
                  </Tooltip>

                  {/* SEND / MIC */}
                  {!privateMessageInputVisible ? (
                    <>
                      {inputMessage || showSelectMessageCheckbox ? (
                        <>
                          {showSelectMessageCheckbox && (
                            <IconButton
                              aria-label="cancelForward"
                              component="span"
                              onClick={handleCancelForwardSelection}
                              disabled={loading}
                              className={classes.cancelForwardBtn}
                            >
                              <Clear size={18} color="currentColor" />
                            </IconButton>
                          )}
                          <IconButton
                            aria-label="sendMessage"
                            component="span"
                            onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                            disabled={loading}
                            className={classes.sendBtn}
                          >
                            {loading ? (
                              <CircularProgress size={20} style={{ color: "#0b7dda" }} />
                            ) : showSelectMessageCheckbox ? (
                              <Reply size={18} style={{ color: "#0b7dda" }} />
                            ) : (
                              <IconSend color="#0b7dda" size={18} />
                            )}
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          aria-label="showRecorder"
                          component="span"
                          disabled={disableOption()}
                          onClick={handleStartRecording}
                          className={classes.inputIconBtn}
                        >
                          <IconMic size={18} color="currentColor" />
                        </IconButton>
                      )}
                    </>
                  ) : (
                    <>
                      {showSelectMessageCheckbox && (
                        <IconButton
                          aria-label="cancelForward"
                          component="span"
                          onClick={handleCancelForwardSelection}
                          disabled={loading}
                          className={classes.cancelForwardBtn}
                        >
                          <Clear size={18} color="currentColor" />
                        </IconButton>
                      )}
                      <IconButton
                        aria-label="sendMessage"
                        component="span"
                        onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                        disabled={loading}
                        className={classes.sendBtn}
                      >
                        {loading ? (
                          <CircularProgress size={20} style={{ color: "#0b7dda" }} />
                        ) : showSelectMessageCheckbox ? (
                          <Reply size={18} style={{ color: "#0b7dda" }} />
                        ) : (
                          <IconSend color="#0b7dda" size={18} />
                        )}
                      </IconButton>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Quick answers drawer */}
            <Drawer
              anchor="right"
              open={quickDrawerOpen}
              onClose={() => { setQuickDrawerOpen(false); setQuickDrawerSearch(""); setQuickDrawerExpanded(null); }}
              className={classes.quickAnswersDrawer}
            >
              <div className={classes.quickAnswersDrawerHeader}>
                <Typography className={classes.quickAnswersDrawerTitle}>
                  {i18n.t("messagesInput.quickReplies.header")}
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => { setQuickDrawerOpen(false); setQuickDrawerSearch(""); setQuickDrawerExpanded(null); }}
                  className={classes.quickAnswersDrawerClose}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = theme.chatiaDS.closeButtonHover.backgroundColor;
                    e.currentTarget.style.color = theme.chatiaDS.closeButtonHover.color;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = theme.chatiaDS.closeButton.backgroundColor;
                    e.currentTarget.style.color = theme.chatiaDS.closeButton.color;
                  }}
                >
                  <CloseXIcon style={{ fontSize: 18 }} />
                </IconButton>
              </div>
              <div className={classes.quickAnswersSearchBox}>
                <Search size={20} />
                <InputBase
                  className={classes.quickAnswersSearchInput}
                  placeholder={i18n.t("messagesInput.quickReplies.searchPlaceholder")}
                  value={quickDrawerSearch}
                  onChange={(e) => setQuickDrawerSearch(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                  onKeyUp={(e) => e.stopPropagation()}
                  inputRef={(input) => { if (input && quickDrawerOpen) input.focus(); }}
                  autoFocus
                />
                {quickDrawerSearch && (
                  <IconButton size="small" onClick={() => setQuickDrawerSearch("")}>
                    <Clear size={16} />
                  </IconButton>
                )}
              </div>
              <div className={classes.quickAnswersListArea}>
                {(() => {
                  const filtered = quickAnswers.filter((m) => {
                    if (!quickDrawerSearch) return true;
                    const s = quickDrawerSearch.toLowerCase();
                    return (
                      m.label.toLowerCase().includes(s) ||
                      m.value.toLowerCase().includes(s)
                    );
                  });
                  if (filtered.length === 0) {
                    return (
                      <div className={classes.quickAnswersEmpty}>
                        <Search size={20} />
                        <span>{i18n.t("messagesInput.quickReplies.empty")}</span>
                      </div>
                    );
                  }
                  return filtered.map((item, index) => {
                    const shortcode = item.label.split(" - ")[0] || item.label;
                    const preview = item.value.length > 60
                      ? item.value.substring(0, 60) + "..."
                      : item.value;
                    const isExpanded = quickDrawerExpanded === index;
                    return (
                      <div key={index} className={classes.quickAnswersCard}>
                        <div
                          className={classes.quickAnswersCardHeader}
                          onClick={() => setQuickDrawerExpanded(isExpanded ? null : index)}
                        >
                          <span className={classes.quickAnswersCardShortcut}>{shortcode}</span>
                          <span className={classes.quickAnswersCardPreview}>
                            {isExpanded ? "" : preview}
                          </span>
                          {isExpanded
                            ? <ExpandLess className={classes.quickAnswersCardExpandIcon} />
                            : <ExpandMore className={classes.quickAnswersCardExpandIcon} />
                          }
                        </div>
                        <Collapse in={isExpanded}>
                          <div className={classes.quickAnswersCardBody}>
                            <div className={classes.quickAnswersCardMessage}>
                              {item.value}
                            </div>
                            <button
                              className={classes.quickAnswersCardUseBtn}
                              onClick={() => {
                                handleQuickAnswersClick(item);
                                setQuickDrawerOpen(false);
                                setQuickDrawerSearch("");
                                setQuickDrawerExpanded(null);
                              }}
                            >
                              {i18n.t("messagesInput.quickReplies.useReply")}
                            </button>
                          </div>
                        </Collapse>
                      </div>
                    );
                  });
                })()}
              </div>
            </Drawer>

            {appointmentModalOpen && (
              <ScheduleModal
                open={appointmentModalOpen}
                onClose={() => setAppointmentModalOpen(false)}
                message={inputMessage}
                contactId={contactId}
              />
            )}
          </div>
          )}
        </Paper>
      </div>
    );
  }
};

export default MessageInput;

